import { getSticker } from "api-function/postContentApi";
import { Snackbar } from "components";

import { AppLog } from "services";
import { AppRecordJK, AppRecordStatusJK, RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import { create } from "zustand";
import { useAppSelector } from "./store";

interface ExploreType {
  initializePage: () => Promise<void>;
  topTenFollowers: any[];
  topTenReachs: any[];
  fetchTopTenFollower: () => Promise<void>;
  fetchTopTenReach: () => Promise<void>;
  topTenFollowerLoading: boolean;
  topTenReachLoading: boolean;
}

export const exploreStore = create<ExploreType>((set, get) => ({
  topTenFollowers: [],
  topTenReachs: [],
  topTenFollowerLoading: false,
  topTenReachLoading: false,
  initializePage: async () => {
    try {
      exploreStore.getState().fetchTopTenFollower();
      exploreStore.getState().fetchTopTenReach();
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
  // getHomeTopTenFollwers getHomeGuestTop10Follwers

  fetchTopTenFollower: async () => {
    try {
      set({ topTenFollowerLoading: true });
      let url = Service.userAuth ? RouteApi.getHomeTopTenFollwers : RouteApi.getHomeGuestTop10Follwers;
      url += `token=${Service.token}`;

      const responses = await RequestApi(url);
      if (responses.status === "success") {
        set((state) => ({
          topTenFollowers: responses.users,
        }));
      } else {
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchTopTenFollower]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      set({ topTenFollowerLoading: false });
    }
  },

  fetchTopTenReach: async () => {
    try {
      set({ topTenReachLoading: true });
      let url = Service.userAuth ? RouteApi.getHomeTopTenReachs : RouteApi.getHomeGuestTop10Reachs;
      url += `token=${Service.token}`;
      const responses = await RequestApi(url);
      if (responses.status === "success") {
        set((state) => ({
          topTenReachs: responses.users, // Assuming `responses.data` is the array
        }));
        //  let tmpPost = structuredClone(post);
        //  const indexUser = tmpPost.suggestion_users.findIndex(
        //    (user: any) => `${user.id}` === userId
        //  );
        //  if (indexUser > -1) {
        //    tmpPost.suggestion_users.splice(indexUser, 1);
        //    const editIndex = posts.findIndex(
        //      (post) => post.provider_post_id === tmpPost.provider_post_id
        //    );
        //    if (editIndex !== -1) {
        //      set((state) => {
        //        const updatedPosts = [...state.posts];
        //        updatedPosts[editIndex] = tmpPost;
        //        return { posts: updatedPosts };
        //      });
        //    }
        //  }
      } else {
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchTopTenReach]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      set({ topTenReachLoading: false });
    }
  },
}));
